export const messages = {
  en: {
    SKU: 'SKU',
    hello: 'H',
    'Initial estimate price': 'Initial estimate price',
    'New Consignment': 'New Consignment',
    Consignment: 'Consignment',
    Customer: 'Customer',
    State: 'State',
    Remark: 'Remark',
    'Received at': 'Received at',
    'Record created at': 'Record created at',
    deliver_to_store: 'Waiting for delivery',
    received: 'Received',
    Checking: 'Checking',
    'Customer review': 'Customer review',
    launch: 'Launch',
    launched: 'Launched',
    complete: 'Complete',
    Return: 'Return',
    Brand: 'Brand',
    Save: 'Save',
    Info: 'Info',
    Prices: 'Prices',
    Status: 'Status',
    Actions: 'Actions',
    Name: 'Name',
    Category: 'Category',
    Condition: 'Condition',
    Product: 'Product',
    Available: 'Available',
    Sold: 'Sold',
    Commission: 'Commission',
    Remove: 'Remove',
    Create: 'Create',
    Select: 'Select',
    Description: 'Description',
    Saved: 'Saved',
    Delete: 'Delete',
    Price: 'Price',
    Discount: 'Discount',
    Properties: 'Properties',
    Size: 'Size',
    Material: 'Material',
    Color: 'Color',
    Patterns: 'Patterns',
    Measurements: 'Measurements',
    bust: 'bust',
    length: 'length',
    hips: 'hips',
    waist: 'waist',
    inseam: 'inseam',
    rise: 'rise',
    width: 'width',
    height: 'height',
    heel: 'heel',
    Search: 'Search',
    Filters: 'Filters',
    Clear: 'Clear',
    Images: 'Images',
    Cancel: 'Cancel',
    Order: 'Order',
    Channel: 'Channel',
    Pickup: 'Pickup',
    Delivery: 'Delivery',
    Subtotal: 'Subtotal',
    Total: 'Total',
    Shop: 'Shop',
    Facebook: 'Facebook',
    Website: 'Website',
    App: 'App',
    Guest: 'Guest',
    Records: 'Records',
    Styles: 'Styles',
    Pending: 'Pending',
    Expired: 'Expired',
    'Retail price': 'Retail price',
    'Current price': 'Current price',
    'Brand size': 'Brand size',
    'Select Customer': 'Select Customer',
    'Select product': 'Select product',
    'Order note': 'Order note',
    'Payment method': 'Payment Method',
    'Delivery fee': 'Delivery fee',
    'Store Credits': 'Store Credits',
    'Please go to product page after created':
      'Please go to product page after created',
    'Available On': 'Available On',
    in_stock: 'In stock',
    'Condition note': 'Condition note',
    'Discontinue On': 'Discontinue On',
    'Admin remark': 'Admin remark',
    'Auto discount': 'Auto discount',
    'Sell price': 'Sell price',
    'Original price': 'Original price',
    'User purchase price': 'User purchase price',
    'User Suggested price': 'User Suggested price',
    'Confirmed price': 'Confirmed price',
    'Payment total': 'Payment total',
    'Add items': 'Add items',
    'Customer Revenue': 'Customer Revenue',
    'Are you sure to delete this item?': 'Are you sure to delete this item?',
    Number: 'Number',
    Email: 'Email',
    Phone: 'Phone',
    Close: 'Close',
    Logout: 'Logout',
    Detail: 'Detail',
    Address: 'Address',
    Province: 'Province',
    Backend: 'Backend',
    District: 'District',
    Staff: 'Staff',
    Orders: 'Orders',
    Surcharges: 'Surcharge',
    'Cash change': 'Cash change',
    'Customer pay': 'Customer pay',
    'Thank you': 'Thank you',
    'Expire date': 'Expire date',
    'Expire at': 'Expire at',
    'No records found': 'No records found',
    'Print Invoice': 'Print Invoice',
    'Completed at': 'Completed at',
    'Order number': 'Order number',
    'Total number of items': 'Total number of items',
    Approver: 'Approver',
    'Sale distribution': 'Sale distribution',
    'Payment methods': 'Payment methods',
    'Sale channels': 'Sale channels',
    'Sale total': 'Sale total',
    'Number of bills': 'Number of bills',
    'Number of items': 'Number of items',
    'Discount total': 'Discount total',
    'Item total': 'Item total',
    'Total amount of payment methods': 'Total amount of payment methods',
    Apply: 'Apply',
    Date: 'Date',
    'Discount programs': 'Discount programs',
    'Shipping method': 'Shipping method',
    'Payout method': 'Payout method',
    'Previous payout items': 'Previous payout items',
    'Unpaid items': 'Unpaid items',
    'Unsold items': 'Unsold items',
    'Returned items': 'Returned items',
    'Export date': 'Export date',
    'Payment date': 'Payment date',
    'Total amount': 'Total amount',
    'Final selling price': 'Final selling price',
    Payout: 'Payout',
    'Additional information': 'Additional information',
    'No record found': 'No record found',
    Revenue: 'Revenue',
    'Payout items': 'Payout items',
    Approve: 'Approve',
    Paid: 'Paid',
    Refresh: 'Refresh',
    'Print payout bill': 'Print payout bill',
    'Print temporary bill': 'Print temporary bill',
    'Previous payout total': 'Previous payout total',
    'Other items': 'Other items',
    'Payout number': 'Payout number',
    'Payout status': 'Payout status',
    'Thank you for choosing a sustainable lifestyle':
      'Thank you for choosing a sustainable lifestyle',
    'Date of Birth': 'Date of Birth',
    Ward: 'Ward',
    Roles: 'Roles',
    Note: 'Note',
    'Reset password': 'Reset password',
    'Payout methods': 'Payout methods',
    Payouts: 'Payouts',
    Consignments: 'Consignments',
    "Please add this information in 'Customers' > 'Payout methods'":
      "Please add this information in 'Customers' > 'Payout methods'",
    "Please add this information in 'Customers' > 'Info'":
      "Please add this information in 'Customers' > 'Info'",
    Accepted: 'Accepted',
    Returned: 'Returned',
    'Not found': 'Not found',
    Rejected: 'Rejected',
    Mode: 'Mode',
    Direct: 'Direct',
    Percentage: 'Percentage',
    'Total items': 'Total items',
    'Product information': 'Product information',
    'Product name': 'Product name',
    'Cost price': 'Cost price',
    Slug: 'Slug',
    Copy: 'Copy',
    Schedule: 'Schedule',
    Discounts: 'Discounts',
    'Add stock': 'Add stock',
    'Drop stock': 'Drop stock',
    'Add a new brand': 'Add a new brand',
    Approved: 'Approved',
    Payments: 'Payments',
    Adjustment: 'Adjustment',
    'Your revenue': 'Your revenue',
    'Delivery bill': 'Delivery bill',
    'Related consignments': 'Related consignments',
    'Consignment list': 'Consignment list',
    Submit: 'Submit',
    'Remove all': 'Remove all',
    'Paid items': 'Paid items',
    'Pending payment items': 'Pending payment items',
    'Add all': 'Add all',
    Reference: 'Reference',
    donate_complete: 'Donate and complete',
    return_delivery: 'Return - Delivery',
    return_pickup: 'Return - Self pick-up',
    'Gained SC points': 'Gained SC points',
    Unsold: 'Unsold',
    'Pending payment': 'Pending payment',
    'Delivery bill total': 'Delivery bill total',
    'Delivery companies': 'Delivery companies',
    'Applied SC Points': 'Applied SC Points',
    'Current SC Points': 'Current SC Points',
    'Created at': 'Created at',
    'Pick up clothing due': 'Pick up clothing due',
    pick_up_clothing_due_info:
      'Customer have to take back their clothes before this date. Otherwise, extra storage fee will be charged',
    Collecting: 'Collecting',
    'Waiting customer': 'Waiting customer',
    'On sales': 'On sales',
    'Are you sure to discount all items': 'Are you sure to discount all items',
    consignment_discount_consignment:
      'The expire date will be added automatically 14 days',
    consignment_discount_product1:
      'The discontinue date will be added automatically 14 days',
    consignment_discount_product2:
      'The price will be discounted automatically according to the discount percentage.',
    consignment_discount_product3:
      'Corresponding discount tags will be added automatically.',
    'Remaining products': 'Remaining products',
    'Related payouts': 'Related payouts',
    measure_shoot: 'Measure and shoot',
    priced_store: 'Store confirmed price',
    priced_customer: 'Customer confirmed price',
    priced_confirmed: 'Confirmed price',
    'Remaining quantity': 'Remaining quantity',
    Quantity: 'Quantity',
    Customers: 'Customers',
    'Re count': 'Re count',
    'Create directly': 'Create directly',
    'Printed at': 'Printed at',
    'Total number of quantity': 'Total number of quantity',
    'In stock quantity': 'In stock quantity',
    'Consignment receipt': 'CONSIGNMENT RECEIPT',
    'Customer name': 'Customer name',
    'Phone number': 'Phone number',
    'Bank account info': 'Bank account info',
    'Selling price': 'Selling price',
    'Ordinal number': 'No.',
    Consignor: 'Consignor',
    'Receiving staff': 'Receiving staff',
    bill_confirm_name: 'My name is',
    bill_confirm_consigned:
      'confirm that I have consigned at Second Corner a total of',
    bill_confirm_items: 'item(s).',
    bill_policy_title:
      'IMPORTANT NOTICE: CUSTOMERS PLEASE READ AND FULLY UNDERSTAND THE CONSIGNMENT POLICY AND REGULATIONS AT SECOND CORNER:',
    bill_direct_title: 'In-Store Consignment',
    bill_direct_1:
      'Consignment Period: 70 days from the date the product is put on sale. When consigned goods are overloaded, processing may take up to 2 more weeks. To know the exact consignment end date, please contact us via Zalo 032.533.7044.',
    bill_online_title: 'Online Consignment',
    bill_online_1: 'Online Quotation Period: Within 2 months at the latest.',
    bill_online_2:
      'Consignment Period: 70 days from the date the product is put on sale. In case consigned goods are overloaded, processing may take up to 2 more weeks. To know the exact consignment end date, please contact us via Zalo 032.533.7044.',
    bill_general_title: 'General Regulations',
    bill_general_1:
      'No Price Changes or Early Withdrawal: During the consignment period, customers cannot change prices, take back items or receive payment earlier than the consignment period.',
    bill_general_2:
      'Early Payment: If customers want to be paid early, an additional 40% fee will be charged on the total early-payment bill. (The store does not encourage this)',
    bill_general_3:
      'Early Withdrawal: If customers want to take back items early, an additional 40% fee will be charged per item taken back. (The store does not encourage this)',
    bill_after_title: 'After the Consignment Period:',
    bill_after_1:
      'Customers may pick up their products within 1 week after receiving the summary file via Zalo. If overdue, a fee of 100,000 VND/week will be charged (automatically deducted from the summary bill).',
    bill_after_2:
      'If items are not picked up after 2 months, the store reserves the full right to handle the returned goods.',
    bill_duty_title: 'Duties and Responsibilities',
    bill_duty_store_1:
      'The Store will notify customers of the product/order status on the settlement date.',
    bill_duty_store_2:
      'The Store will display, introduce and sell products within the scope of the consignment service.',
    bill_duty_store_3:
      "The Store will preserve goods under normal conditions at the Store. The Store is not liable for compensation for products that are fragile or prone to peeling, fading or natural wear during display and fitting. (Damage risks during consignment and fitting are unavoidable and beyond the Store's control. High-risk goods include but are not limited to: lace, mesh, woven fabrics (tweed, wool, felt…), beaded, sequin or glitter products, easily stained products (linen, white items…), and products with weak stitching. For cosmetics: quality and color may change, evaporate in the air, oxidize…)",
    bill_duty_customer_1:
      'Customers commit to and are responsible for the quality, origin and authenticity of consigned products, and must provide full information about consigned goods upon request. Customers are responsible for any issues arising in relation to the products.',
    bill_duty_customer_2:
      "Customers must truthfully provide information about the condition of consigned products. If fake or poor-quality goods are found, the Store will withdraw the products and return them. Any issues arising in relation to the products are the Customer's responsibility to resolve.",
    bill_terms:
      "The contents stated above have the validity of consignment contract terms. Any dispute arising from the Customer's failure to comply with these terms will not be accepted for resolution, and in such cases the Store's decision will be final.",
    bill_thanks:
      "Second Corner kindly asks our Customers to take note and commit clearly so that we can cooperate well and long-term together. Thank you for trusting and using Second Corner's services ❤",
    'Bill number': 'Bill number',
    'Consignment number': 'Consignment number',
    'Consigned product': 'Consigned Product',
    payout_bill_title: 'CONSIGNMENT RECONCILIATION & PAYOUT SUMMARY',
    payout_payment_date: 'Consignment Payment Date',
    payout_customer_name: 'Consignment Customer Name',
    payout_reconcile_intro:
      'Both parties have reconciled the consigned products and agreed as follows:',
    payout_sold_products_title: 'SOLD PRODUCTS',
    payout_th_fee_percent: '% Service Fee',
    payout_th_fee: 'Service Fee',
    payout_th_customer_revenue: 'Customer Receives',
    payout_th_customer_revenue_total: 'Total Customer Receives',
    payout_total_after_fee: 'Total amount customer receives after fees',
    payout_returned_products_title: 'RETURNED CONSIGNED PRODUCTS (Unsold)',
    payout_th_returned_product: 'Returned Consigned Product',
    payout_th_returned_quantity: 'Returned Quantity',
    payout_total_returned_quantity: 'Total returned quantity',
    products_unit: 'product(s)',
    payout_note_title: 'NOTE',
    payout_note_1:
      'Before the consignment payout is made, the store will send a Reconciliation & Consignment Summary notice. Customers should pick up their unsold consigned items (if any) within 1 week from the date of the notice. If customers cannot come to pick up the returned items, they can ask the store to ship them back (shipping fee paid by the customer) or donate them to charity. If more than 1 week has passed since the notice was sent and the items have still not been picked up, the store will start charging a storage fee of 100,000 VND/week (automatically deducted from the consignment payout bill).',
    payout_note_2:
      'After 2 months, if the items have still not been picked up, the store reserves the full right to handle them. The store respectfully declines to resolve any case where the customer has not contacted us after 2 months.',
    payout_date_line: 'Date: {day}/{month}/{year}',
    payout_sign_confirm: 'Customer, please sign to confirm the payment',
    payout_thanks:
      'Thank you for trusting and using the services at Second Corner!',
    payout_temp_title: 'TEMPORARY BILL',
    payout_temp_warning: 'For reference only - NOT APPROVED',
    payout_temp_warning_2: 'The official bill will be provided after approval',
    payout_th_qty_short: 'Qty',
    payout_total_products: 'Total Products',
    payout_temp_remaining_title: 'REMAINING CONSIGNED PRODUCTS (Unsold)',
    payout_th_remaining_qty: 'Remaining Qty',
    payout_temp_none: 'No remaining products',
    payout_total_remaining_quantity: 'Total Remaining Quantity',
    payout_temp_verify: 'Please verify the product information and amounts',
  },
  vi: {
    SKU: 'SKU',
    hello: 'Xin chào',
    'Initial estimate price': 'Giá ban đầu',
    'New Consignment': 'Ký gửi mới',
    Consignment: 'Ký gửi',
    Customer: 'Khách hàng',
    State: 'Tình trạng',
    Remark: 'Nhận xét',
    'Received at': 'Nhận tại',
    'Record created at': 'Thông tin được tạo lúc',
    deliver_to_store: 'Đang chờ giao hàng',
    received: 'Đã nhận',
    Checking: 'Đang kiểm tra',
    'Customer review': 'Đợi khách hàng đồng ý',
    launch: 'Ra mắt',
    Launched: 'Ra mắt',
    complete: 'Hoàn thành',
    Return: 'Hoàn trả',
    Brand: 'Thương hiệu',
    Save: 'Lưu',
    Info: 'Thông tin',
    Prices: 'Giá',
    Status: 'Trạng thái',
    Actions: 'Hành động',
    Name: 'Tên',
    Category: 'Danh mục',
    Condition: 'Điều kiện',
    Product: 'Sản phẩm',
    Available: 'Còn hàng',
    Sold: 'Hết hàng',
    Commission: 'Hoa hồng',
    Remove: 'Loại bỏ',
    Create: 'Tạo',
    Select: 'Chọn',
    Description: 'Miêu tả',
    Saved: 'Đã lưu',
    Delete: 'Xóa',
    Price: 'Gía',
    Discount: 'Giảm giá',
    Properties: 'Tính ',
    Size: 'Size',
    Material: 'Chất liệu',
    Color: 'Màu',
    Patterns: 'Hoa văn',
    Measurements: 'Đo',
    bust: 'vòng ngực',
    length: 'chiều dài',
    hips: 'hông',
    waist: 'eo',
    inseam: 'đường may sườn trong',
    rise: 'cạp quần',
    width: 'chiều rộng',
    height: 'chiều cao',
    heel: 'cao gót',
    Search: 'Tìm kiếm',

    Filters: 'Phân loại',
    Clear: 'Xoá',
    Images: 'Hình ảnh',
    Cancel: 'Huỷ',
    Order: 'Đặt',
    Channel: 'Kênh',
    Pickup: 'Lấy hàng',
    Delivery: 'Giao hàng',
    Subtotal: 'Subtotal',
    Total: 'Tổng cộng',
    Shop: 'Cửa hàng',
    Facebook: 'Facebook',
    Website: 'Website',
    App: 'App',
    Guest: 'Khách hàng',
    Records: 'Bản ghi',
    Styles: 'Phong cách',
    Pending: 'Đang chờ xử lý',
    Expired: 'Đã hết hạn',
    'Retail price': 'Giá bán lẻ',
    'Current price': 'Giá hiện tại',
    'Brand size': 'Kích cỡ thương hiệu',
    'Select Customer': 'Chọn khách hàng',
    'Select product': 'Chọn sản phẩm',
    'Order note': 'Ghi chú đơn hàng',
    'Payment method': 'Phương thức thanh toán',
    'Delivery fee': 'Phí giao hàng',
    'Store Credits': 'Tín dụng của cửa hàng',
    'Please go to product page after created':
      'Vui lòng truy cập trang sản phẩm sau khi ',
    'Available On': 'Có sẵn tại',
    in_stock: 'Còn hàng',
    'Condition note': 'Điều kiện lưu ý',
    'Discontinue On': 'Ngừng',
    'Admin remark': 'Nhận xét của quản trị viên',
    'Auto discount': 'Giảm giá tự động',
    'Sell price': 'Giá khuyến mãi',
    'Original price': 'Giá gốc',
    'User purchase price': 'Giá mua của người dùng',
    'User Suggested price': 'Giá do người dùng đề xuất',
    'Confirmed price': 'Giá đã xác nhận',
    'Payment total': 'Tổng tiền phải trả',
    'Add items': 'Thêm sản phẩm',
    'Customer Revenue': 'Doanh thu khách hàng',

    'Are you sure to delete this item?': 'Bạn có chắc muốn xóa sản phẩm?',
    Number: 'Số',
    Email: 'Email',
    Phone: 'Số điện thoại',
    Close: 'Đóng',
    Logout: 'Đăng xuất',
    Detail: 'Chi tiết',
    Address: 'Địa chỉ',
    Province: 'Tỉnh',
    Backend: 'Backend',
    District: 'Quận',
    Staff: 'Nhân viên',
    Orders: 'Đơn hàng',
    Surcharges: 'Phụ phí',
    'Cash change': 'Tiền thối',
    'Customer pay': 'Khách đưa',
    'Thank you': 'Cảm ơn',
    'Expire date': 'Ngày hết hạn',
    'Expire at': 'Ngày hết hạn',
    'No records found': 'Không có dữ liệu',
    'Print Invoice': 'In hoá đơn',
    'Completed at': 'Hoàn thành vào',
    'Order number': 'Mã số đơn hàng',
    'Total number of items': 'Tổng số mặt hàng',
    Approver: 'Người nhận Ký Gửi',
    'Sale distribution': 'Phân phối bán hàng',
    'Payment methods': 'Phương thức thanh toán',
    'Sale channels': 'Kênh Bán Hàng',
    'Sale total': 'Doanh Thu',
    'Number of bills': 'Số lượng bill',
    'Number of items': 'Số lượng sản phẩm',
    'Discount total': 'Tổng giảm giá',
    'Item total': 'Tổng sản phẩm',
    'Total amount of payment methods': 'Hình thức thanh toán',
    Apply: 'Áp dụng',
    Date: 'Ngày',
    'Discount programs': 'Chương trình giảm giá',
    'Shipping method': 'Phương thức gửi hàng',
    'Payout method': 'Phương thức thanh toán',
    'Previous payout items': 'Các mặt hàng đã thanh toán trước đây',
    'Unpaid items': 'Các sản phẩm chưa thanh toán',
    'Unsold items': 'Các sản phẩm chưa bán',
    'Returned items': 'Các sản phẩm hoàn trả',
    'Export date': 'Ngày xuất',
    'Payment date': 'Ngày thanh toán',
    'Total amount': 'Tổng tiền',
    'Final selling price': 'Giá bán cuối cùng',
    Payout: 'Thanh toán',
    'Additional information': 'Thông tin thêm',
    'No record found': 'Không tìm thấy dữ liệu',
    Revenue: 'Doanh thu',
    'Payout items': 'SẢN PHẨM KÝ GỬI ĐÃ BÁN',
    Approve: 'Duyệt',
    Paid: 'Đã thanh toán',
    Refresh: 'Tải lại',
    'Print payout bill': 'In hoá đơn thanh toán',
    'Print temporary bill': 'In hoá đơn tạm thời',
    'Previous payout total': 'Tổng thanh toán trước',
    'Other items': 'Các sản phẩm khác',
    'Payout number': 'Mã số thanh toán',
    'Payout status': 'Tình trạng thanh toán',
    'Thank you for choosing a sustainable lifestyle':
      'Cảm ơn bạn đã lựa chọn lối sống tiết kiệm',
    'Date of Birth': 'Ngày sinh',
    Ward: 'Phường',
    Roles: 'Vai trò',
    Note: 'Ghi chú',
    'Reset password': 'Đặt lại mật khẩu',
    'Payout methods': 'Phương thức thanh toán',
    Payouts: 'Thanh toán',
    Consignments: 'Ký gửi',
    "Please add this information in 'Customers' > 'Payout methods'":
      " Vui lòng thêm thông tin  'Khách hàng'  > ‘Phương thức thanh toán",
    "Please add this information in 'Customers' > 'Info'":
      "Vui lòng thêm thông tin  'Khách hàng' > 'Thông tin'",
    Accepted: 'Chấp nhận',
    Returned: 'Hoàn lại',
    'Not found': 'Không tìm thấy',
    Rejected: 'Loại bỏ',
    Mode: 'Chế độ',
    Direct: 'Trực tiếp',
    Percentage: 'Phần trăm',
    'Total items': 'Tổng các sản phẩm',
    'Product information': 'Thông tin sản phẩm',
    'Product name': 'Tên sản phẩm',
    'Cost price': 'Giá bán lẻ ban đầu',
    Slug: 'Mô tả sản phẩm',
    Copy: 'Sao chép',
    Schedule: 'Bản liệt kê',
    Discounts: 'Giảm giá',
    'Add stock': 'Thêm vào kho',
    'Drop stock': 'Giảm số lượng kho',
    'Add a new brand': 'Thêm một thương hiệu mới',
    Approved: 'Đã được phê duyệt',
    Payments: 'Thanh toán',
    Adjustment: 'Điều chỉnh',
    'Your revenue': 'Doanh thu của bạn',
    'Delivery bill': 'Hóa đơn giao hàng',
    'Related consignments': 'Đơn ký gửi liên quan',
    'Consignment list': 'Danh sách kí gửi',
    Submit: 'Nộp',
    'Remove all': 'Xóa bỏ tất cả',
    'Paid items': 'Các mặt hàng phải trả phí',
    'Pending payment items': 'Đang chờ xử lí',
    'Add all': 'Thêm tất cả',
    Reference: 'Tham khảo',
    donate_complete: 'Đóng góp và hoàn thành',
    return_delivery: 'Trả lại hàng hóa - Vận chuyển',
    return_pickup: 'Trả lại hàng hóa - Tự nhận',
    'Gained SC Points': 'Đã đạt được điểm SC',
    Unsold: 'Chưa bán được',
    'Pending payment': 'Trong khi chờ thanh toán',
    'Delivery bill total': 'Tổng hóa đơn giao hàng',
    'Delivery companies': 'Công ty giao hàng',
    'Applied SC Points': 'SC Points được áp dụng',
    'Current SC Points': 'SC Points hiện tại',
    'Created at': 'Được tạo lúc',
    'Pick up clothing due': 'Hạn lấy quần áo',
    pick_up_clothing_due_info:
      'Khách hàng phải lấy quần áo của họ lại trước ngày Return day. Nếu trễ hơn ngày này, khách hàng sẽ bị tính phí lưu kho.',
    Collecting: 'Sưu tập',
    'Waiting customer': 'Khách hàng đang đợi',
    'On sales': 'Đang bán',
    'Are you sure to discount all items':
      'Bạn có chắc sẽ giảm giá các món hàng này không?',
    consignment_discount_consignment:
      'Ngày hết hạn sẽ được tự động cộng thêm 14 ngày.',
    consignment_discount_product1:
      'Ngày ngừng sẽ được tự động cộng thêm 14 ngày.',
    consignment_discount_product2:
      'Giá sẽ được tự động giảm theo phần trăm giảm giá.',
    consignment_discount_product3:
      'Nhãn giảm giá tương ứng sẽ được tự động gắn.',
    'Remaining products': 'Các sản phẩm còn lại.',
    'Related payouts': 'Thanh toán liên quan',
    measure_shoot: 'Đo lường và chụp hình',
    priced_store: 'Giá cửa hàng',
    priced_customer: 'khách hàng định giá',
    priced_confirmed: 'Xác nhận giá',
    // pricing_customer: 'Giá bán (Chờ khách hàng)',
    // pricing_store: 'Giá bán (Cửa hàng)',
    'Remaining quantity': 'Số lượng còn lại',
    Quantity: 'Số lượng',
    Customers: 'Khách hàng',
    'Re count': 'đếm lại',
    'Create directly': 'Tạo trực tiếp',
    'Printed at': 'Được in tại',
    'Total number of quantity': 'Tổng số lượng',
    'In stock quantity': 'Số lượng còn hàng',
    bank_transfer: 'Chuyển khoản ngân hàng',
    cash: 'Tiền mặt',
    'Consignment receipt': 'BIÊN NHẬN KÝ GỬI',
    'Customer name': 'Tên khách hàng',
    'Phone number': 'Số điện thoại',
    'Bank account info': 'Thông tin STK',
    'Selling price': 'Giá bán',
    'Ordinal number': 'STT',
    Consignor: 'Người ký gửi',
    'Receiving staff': 'Nhân viên tiếp nhận',
    bill_confirm_name: 'Tôi tên là',
    bill_confirm_consigned: 'xác nhận đã ký gửi tại Second Corner tổng',
    bill_confirm_items: 'món.',
    bill_policy_title:
      'LƯU Ý QUAN TRỌNG, KHÁCH HÀNG VUI LÒNG XEM VÀ NẮM RÕ CHÍNH SÁCH, NỘI QUY KÝ GỬI TẠI SECOND CORNER:',
    bill_direct_title: 'Ký Gửi Trực Tiếp',
    bill_direct_1:
      'Thời Hạn Ký Gửi: 70 ngày kể từ ngày treo bán sản phẩm. Tuỳ thời điểm hàng hoá ký gửi quá tải, tiến độ xử lý có thể kéo dài tối đa 2 tuần. Để biết thời hạn kết thúc ký gửi chính xác, Khách vui lòng liên hệ qua Zalo 032.533.7044.',
    bill_online_title: 'Ký Gửi Online',
    bill_online_1: 'Thời Hạn Gửi Báo Giá Online: Chậm nhất là 2 tháng.',
    bill_online_2:
      'Thời Hạn Ký Gửi: 70 ngày kể từ ngày treo bán sản phẩm. Trong trường hợp hàng hóa ký gửi quá tải, tiến độ xử lý có thể kéo dài tối đa 2 tuần. Để biết thời hạn kết thúc ký gửi chính xác, Khách vui lòng liên hệ qua Zalo 032.533.7044.',
    bill_general_title: 'Quy Định Chung',
    bill_general_1:
      'Không Thay Đổi Giá và Lấy Đồ: Trong thời gian ký gửi, Khách không thể thay đổi giá, lấy đồ hoặc thanh toán sớm hơn so với thời hạn ký gửi.',
    bill_general_2:
      'Thanh toán Sớm: Nếu Khách muốn thanh toán sớm, sẽ chịu thêm phí 40% trên tổng bill thanh toán sớm của Khách. (Cửa hàng không khuyến khích điều này)',
    bill_general_3:
      'Lấy Đồ Sớm: Nếu Khách muốn lấy đồ sớm, sẽ chịu thêm phí 40% trên mỗi sản phẩm lấy về. (Cửa hàng không khuyến khích điều này)',
    bill_after_title: 'Sau Thời Hạn Ký Gửi:',
    bill_after_1:
      'Khách có thể đến lấy lại sản phẩm trong vòng 1 tuần sau khi nhận được file đơn tổng kết qua Zalo. Nếu quá hạn, sẽ tính phí 100.000 VNĐ/tuần (phí sẽ được trừ tự động vào đơn tổng kết).',
    bill_after_2:
      'Sau 2 tháng khách không quá lấy đồ, cửa hàng sẽ toàn quyền xử lý đồ hoàn về.',
    bill_duty_title: 'Nhiệm Vụ và Trách Nhiệm',
    bill_duty_store_1:
      'Cửa Hàng sẽ thông báo về tình trạng sản phẩm/đơn hàng khi đến ngày tất toán.',
    bill_duty_store_2:
      'Thực hiện trưng bày, giới thiệu và bán sản phẩm trong phạm vi dịch vụ ký gửi.',
    bill_duty_store_3:
      'Thực hiện bảo quản hàng hóa trong điều kiện thông thường tại Cửa hàng. Cửa hàng không chịu trách nhiệm bồi thường đối với các sản phẩm có tính chất dễ hư hại, bong tróc, bạc màu hoặc hao mòn tự nhiên trong quá trình trưng bày và thử đồ.(Rủi ro hư hại trong quá trình ký gửi và thử đồ là điều khó tránh khỏi và ngoài tầm kiểm soát của Cửa hàng. Nhóm hàng hóa có nguy cơ cao bao gồm nhưng không giới hạn ở: vải ren, lưới, dệt sợi (tweed, len, dạ…), sản phẩm đính cườm, sequin, kim tuyến, sản phẩm dễ ố màu (linen, lanh, đồ trắng…), các sản phẩm có kiểu may không chắc chắn. Đối với mỹ phẩm: có thể thay đổi chất lượng, màu sắc, bị bay hơi trong không khí, oxy hóa…)',
    bill_duty_customer_1:
      'Khách hàng cam kết và chịu trách nhiệm về chất lượng, nguồn gốc, tính nguyên bản của sản phẩm ký gửi. Cung cấp các thông tin đầy đủ của hàng hoá ký gửi khi yêu cầu. Các vấn đề phát sinh liên quan đến sản phẩm sẽ do Khách hàng chịu trách nhiệm.',
    bill_duty_customer_2:
      'Đảm bảo cung cấp trung thực thông tin về tình trạng sản phẩm ký gửi. Nếu phát hiện hàng Fake, kém chất lượng, Cửa hàng sẽ thu hồi sản phẩm và hoàn lại. Mọi vấn đề phát sinh liên quan đến sản phẩm thuộc trách nhiệm giải quyết của Khách hàng.',
    bill_terms:
      'Các nội dung nêu trên có giá trị như điều khoản hợp đồng ký gửi. Mọi tranh chấp phát sinh do Khách hàng không tuân thủ đúng các điều khoản sẽ không được chấp thuận giải quyết, khi đó quyết định của Cửa hàng sẽ là quyết định cuối cùng.',
    bill_thanks:
      'Second Corner mong Quý Khách Hàng lưu ý và cam kết rõ ràng để cùng nhau hợp tác tốt đẹp và bền lâu. Cảm ơn Quý Khách Hàng đã tin tưởng và sử dụng dịch vụ tại Second Corner ❤',
    'Bill number': 'Mã Phiếu',
    'Consignment number': 'Mã Ký Gửi',
    'Consigned product': 'Sản Phẩm Ký Gửi',
    payout_bill_title: 'PHIẾU ĐỐI SOÁT & TỔNG KẾT THANH TOÁN KÝ GỬI',
    payout_payment_date: 'Ngày Thanh Toán Ký Gửi',
    payout_customer_name: 'Tên khách hàng Ký Gửi',
    payout_reconcile_intro:
      'Hai bên tiến hành đối soát các sản phẩm ký gửi và thống nhất như sau:',
    payout_sold_products_title: 'SẢN PHẨM ĐÃ BÁN',
    payout_th_fee_percent: '% Phí DV Ký Gửi',
    payout_th_fee: 'Phí DV Ký Gửi',
    payout_th_customer_revenue: 'Khách Nhận Lại',
    payout_th_customer_revenue_total: 'Tổng KH Nhận Lại',
    payout_total_after_fee: 'Tổng tiền KH nhận sau trừ phí',
    payout_returned_products_title: 'SẢN PHẨM KÝ GỬI HOÀN TRẢ (Chưa bán được)',
    payout_th_returned_product: 'Sản Phẩm Ký Gửi Hoàn Về',
    payout_th_returned_quantity: 'Số Lượng Hoàn Về',
    payout_total_returned_quantity: 'Tổng số lượng hoàn trả',
    products_unit: 'sản phẩm',
    payout_note_title: 'LƯU Ý',
    payout_note_1:
      'Trước khi thanh toán đơn Ký gửi, cửa hàng sẽ gửi thông báo Phiếu Đối Soát - Tổng Kết Ký Gửi, khách đến lấy lại sản phẩm ký gửi đồ tồn chưa bán được (Nếu có) trong thời gian 1 tuần kể từ ngày nhận thông báo. Trường hợp khách không thể đến nhận đồ hoàn, có thể nhắn cửa hàng ship về (phí ship khách thanh toán) hoặc gửi từ thiện. Nếu quá thời hạn 1 tuần kể từ ngày gửi thông báo, khách vẫn chưa lấy đồ tồn, cửa hàng bắt đầu tính phí lưu kho phát sinh 100k/tuần (Phí sẽ được trừ tự động vào đơn thanh toán Ký Gửi).',
    payout_note_2:
      'Sau 2 tháng khách chưa qua lấy đồ tồn, cửa hàng sẽ toàn quyền xử lý. Cửa hàng xin phép từ chối giải quyết mọi trường hợp nếu khách hàng không liên hệ sau 2 tháng.',
    payout_date_line: 'Ngày {day} Tháng {month} Năm {year}',
    payout_sign_confirm: 'Khách Hàng vui lòng ký tên xác nhận đã thanh toán',
    payout_thanks:
      'Cảm ơn Quý Khách Hàng đã tin tưởng và sử dụng dịch vụ tại Second Corner!',
    payout_temp_title: 'PHIẾU ĐỐI SOÁT TẠM TÍNH',
    payout_temp_warning: 'Phiếu mang tính tham khảo - CHƯA ĐƯỢC DUYỆT',
    payout_temp_warning_2: 'Phiếu chính thức có giá trị SAU KHI ĐƯỢC DUYỆT',
    payout_th_qty_short: 'SL',
    payout_total_products: 'Tổng Số Sản Phẩm',
    payout_temp_remaining_title: 'SẢN PHẨM KÝ GỬI CÒN LẠI (Chưa bán được)',
    payout_th_remaining_qty: 'SL Còn Lại',
    payout_temp_none: 'Không có sản phẩm còn lại',
    payout_total_remaining_quantity: 'Tổng Số Lượng Còn Lại',
    payout_temp_verify: 'Vui lòng kiểm tra thông tin sản phẩm và số tiền',
  },
}
